import { render } from "./CardInfo.vue?vue&type=template&id=0143dd6c&scoped=true&ts=true"
import script from "./CardInfo.vue?vue&type=script&lang=ts"
export * from "./CardInfo.vue?vue&type=script&lang=ts"

import "./CardInfo.vue?vue&type=style&index=0&id=0143dd6c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0143dd6c"]])

export default __exports__